import "./help.css";

const Help = () => {

    return (
        <div>
            <SeasonManagement />
            <EarningsDocumentation/>
            <CancelReservationDocumentation/>
        </div>
    );
};

export default Help;


const EarningsDocumentation = () => {
  return (
    <div className="season-container">
      <h1 className="season-heading">2. Earnings Management Documentation</h1>

      <section className="earnings-section">
        <h2 className="season-subheading">Overview</h2>
        <p className="season-text">
          The <strong>Earnings</strong> section handles payments between <strong>Hunters</strong>, <strong>Landowners</strong>, and <strong>Admin</strong> using Stripe.
        </p>
      </section>

      <section className="earnings-section">
        <h2 className="season-subheading">How Earnings Work</h2>
        <ul className="earnings-list">
          <li>Hunters pay <strong>slot price + $4.95 per slot booking fee</strong>.</li>
          <li>Stripe charges a <strong>3% fee</strong> on the total reservation amount.</li>
          <li>Admin can set a <strong>default or individual commission</strong> for each landowner.</li>
          <li>Landowner earnings = (Total reservation amount - booking fee) * Landowner commsion in percentage .</li>
        </ul>
      </section>

      <section className="earnings-section">
        <h2 className="season-subheading">Example Calculation</h2>
        <table className="earnings-table">
          <thead>
            <tr>
              <th>Component</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Slot Price (2 slots @ $100)</td>
              <td>$200</td>
            </tr>
            <tr>
              <td>Booking Fee ($4.95 x 2)</td>
              <td>$9.9 (to admin)</td>
            </tr>
            <tr>
              <td>Landowner Commission (50%)</td>
              <td>50%</td>
            </tr>
            <tr>
              <td><strong>Landowner Earnings</strong></td>
              <td><strong>$95.05</strong></td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="earnings-section">
        <h2 className="season-subheading">Payment Threshold & Request</h2>
        <p className="season-text">
          Landowners can request payouts only when their earnings exceed the <strong>minimum threshold</strong> set by Admin. Once eligible, payouts are sent <strong>instantly via Stripe Connect</strong> from Admin’s account to the Landowner’s Stripe account.
        </p>
      </section>
    </div>
  );
};


const SeasonManagement = () => {
    return (
        <div className="season-container">
            <h1 className="season-heading">1. Season Management Documentation</h1>

            <section className="season-section">
                <h2 className="season-subheading">Overview</h2>
                <p className="season-text">
                    The <strong>Season Management</strong> module enables the admin to define specific seasonal periods using a date range. These seasons are then utilized across the system to filter:
                </p>
                <ul className="season-list">
                    <li>Reservation data</li>
                    <li>Membership information</li>
                    <li>Earnings reports</li>
                </ul>
            </section>

            <section className="season-section">
                <h2 className="season-subheading">Default Season Range</h2>
                <p className="season-text">
                    By default, each season spans from:
                    <br />
                    <strong>June 1st of the current year to May 31st of the following year</strong>
                </p>

                <p className="season-text">Example Seasons:</p>
                <ul className="season-list">
                    <li><strong>Season 2025–2026</strong>: June 1, 2025 – May 31, 2026</li>
                    <li><strong>Season 2026–2027</strong>: June 1, 2026 – May 31, 2027</li>
                </ul>
            </section>
        </div>
    );
};


const CancelReservationDocumentation = () => {
  return (
    <div className="season-container">
      <h1 className="season-heading">3. Cancel Reservation Process Documentation</h1>

      <section className="cancel-section">
        <h2 className="season-subheading">Overview</h2>
        <p className="season-text">
          This section outlines the cancellation rules for reservations based on status and user role (User, Landowner, or Admin).
        </p>
      </section>

      <section className="cancel-section">
        <h2 className="season-subheading">Cancel Scenarios</h2>

        <div className="cancel-case">
          <h3>User Cancel a Pending Reservation</h3>
          <ul className="cancel-list">
            <li>Allowed if reservation is <strong>pending (not paid)</strong>.</li>
            <li>No emails or notifications are sent.</li>
            <li>Reservation is simply canceled or removed.</li>
          </ul>
        </div>

        <div className="cancel-case">
          <h3>User Cancel a Booked Reservation</h3>
          <ul className="cancel-list">
            <li>Allowed even if the reservation is <strong>booked (paid)</strong>.</li>
            <li><strong>Email</strong> is sent to the Landowner with reservation link.</li>
            <li><strong>Notification</strong> sent to both Landowner and Admin.</li>
            <li><strong>No refund</strong> is issued.</li>
          </ul>
        </div>

        <div className="cancel-case">
          <h3>Landowner or Admin Cancel a Reservation</h3>
          <ul className="cancel-list">
            <li>Both can cancel any reservation (pending or booked).</li>
            <li><strong>Email</strong> and <strong>notification</strong> sent to the user.</li>
            <li><strong>No refund</strong> is issued.</li>
          </ul>
        </div>
      </section>

      <section className="cancel-section">
        <h2 className="season-subheading">Refund Policy</h2>
        <p className="season-text">
          In <strong>all cases</strong>, no refund is issued when a reservation is canceled, regardless of who cancel it.
        </p>
      </section>
    </div>
  );
};
